import playButton from 'assets/svg/images/play-button.svg';
import { translate } from 'translations/translator';
const tAria = (key, options?) => translate('a11y', key, options);

function ButtonOverlay(props) {
  return (
    <div className={`button-overlay ${props.show ? '' : 'hidden'}`}>
      <button
        className={`play-button ${props.show ? '' : 'hidden'}`}
        onTouchEnd={props.onClick}
        onClick={props.onClick}
        tabIndex={1}
        aria-label={tAria('play')}
      >
        <img
          alt=''
          className={`button-icon ${props.show ? '' : 'hidden'}`}
          src={playButton}
        />
      </button>
    </div>
  );
}

export default ButtonOverlay;
